<h2>Upcoming Events</h2>
<p>The next two events on our schedule</p>
<ng-container *ngIf="upcomingEvents.length > 0; else emptyEvents">
  <div class="row">
    <div class="col-12 col-xl-6" *ngFor="let event of upcomingEvents">
      <app-event [event]="event"></app-event>
    </div>
  </div>
</ng-container>
<div class="row">
  <div class="col-12">
    <a class="col-12 btn btn-primary" routerLink="/events">See All Events</a>
  </div>
</div>

<ng-template #emptyEvents>
  <ngb-alert type="secondary" [dismissible]="false">
    <span>There are no upcoming events</span>
  </ngb-alert>
</ng-template>
